module.exports = __webpack_public_path__ + "img/YYFAX-FPD-detail.b8b3e105.png";